// UpsellBadge — marks a cart/order line that was added from another item's
// upsell list. Renders nothing for ordinary lines.
import Badge from '@components/base/Badge';

const STYLE = {
  marginInlineStart: 6,
  verticalAlign: 'middle',
  fontSize: 11,
  lineHeight: '18px',
  color: 'var(--color-primary)',
  borderColor: 'var(--color-primary)',
  background: 'transparent',
};

export default function UpsellBadge({ line, t }) {
  if (!line?.isUpsellingItem) return null;
  return <Badge label={t ? t('upsellBadge', 'Upsell') : 'Upsell'} style={STYLE} />;
}
